export default {
	//测试服
	// apiDomain: "http://115.159.44.133:8992/",
	apiDomain: "http://app.xunjiepdf.com/",
	productInfo: "FE82441231A3935E311B420DD522935CBA59C599836370629FFA7A815F29F8B0F8BFD9DB8C32B610",
	code: 10000,
	productId: 133,
	productName: "CompressMagician",
	//套餐列表
	PAY_PACKAGES: [
		{
			id: 88,
			realId: 305,
			name: "终身",
			price: 88,
			// priceOri: 188,
			// priceDis: 78, //挽留后的价格
			// msg: "一次购买，终身享用",
			paypack:
				"83FA527BC948024DAC49AC5DB84A4380650A09B150EAFE628802B3949340E466EAE3C441037F4CEFE2E1FBFB0D7D6F4D",
			// "6C552C254B853C29AC49AC5DB84A4380609B19CC9AE66827D902F587138432481AEC50CAFE5589418B0C5FB46DF29FF5",
			paypackDis: " ",
			zfbpaypack: "C2A48DEB6F7A74E2E832A128B3A78314",
			// "6C552C254B853C290088DCF516F97A54609B19CC9AE66827D902F587138432481AEC50CAFE5589418B0C5FB46DF29FF5", //挽留后的
			// "paypack": "E303447D1520DC614329D83527E218E11B66EBC638011628F8CD583329B68E9965FD7714B9D52F9A157FD5D241F77C05", //0.01
		},
		{
			id: 68,
			realId: 304,
			name: "12个月",
			price: 68,
			priceOri: null,
			// msg: "仅5.7元/月",
			paypack:
				"7224C27AD35FA3782115F52178D6AB4F650A09B150EAFE628802B3949340E466EAE3C441037F4CEFE2E1FBFB0D7D6F4D",
			zfbpaypack: "E4A5FF3BABDF4293E335129A9A1EA650",
			// "A6E82417A8E8D3912115F52178D6AB4F609B19CC9AE66827D902F587138432481AEC50CAFE5589418B0C5FB46DF29FF5",
			// "paypack": "12357DD20F902251A4A81BED8DB3A8310B8D3DC52AB2DA966BFB21D90020793019A543470E24AB73812115197DD1B839", //0.01
		},
		{
			id: 48,
			realId: 532,
			name: "1个月",
			price: 48,
			priceOri: null,
			// msg: "仅8元/月",
			paypack:
				"3C877FA2C2110082ACA6AD2EFFDB7FA0650A09B150EAFE628802B3949340E466EAE3C441037F4CEFE2E1FBFB0D7D6F4D",
			zfbpaypack: "7376FBBD2F95B52D5907D9ED6E65FF19",
			// "21ABBA92007FE8F5ACA6AD2EFFDB7FA0609B19CC9AE66827D902F587138432481AEC50CAFE5589418B0C5FB46DF29FF5",
			// "paypack": "7A53E83DDC9762F6A4A81BED8DB3A8310B8D3DC52AB2DA966BFB21D90020793019A543470E24AB73812115197DD1B839", //0.01
		},
	],
	// 优惠套餐
	PAY_Less_PACKAGES: [
		{
			id: 78,
			realId: 305,
			paypack:
				"83FA527BC948024D0088DCF516F97A54650A09B150EAFE628802B3949340E4660416F901E35D2563E2E1FBFB0D7D6F4D",
			zfbpaypack: "7B0641C0C90E3D09E832A128B3A78314",
		},
	],
};
